/**
 * Sets a specified key-value pair in the localStorage.
 *
 * @param {string} key - The key to set in localStorage.
 * @param {string} value - The value to associate with the key in localStorage.
 */
export function setKey(key: string, value: string) {
  if (typeof window !== "undefined") localStorage.setItem(key, value);
}

/**
 * Retrieves a specified key-value pair in the localStorage.
 *
 * @param {string} key - The key to set in localStorage.
 */
export const getKey = (key: string) => {
  if (typeof window === "undefined") {
    return false;
  }

  if (localStorage.getItem(key)) {
    return localStorage.getItem(key);
  } else {
    return false;
  }
};

/**
 * Removes a specified key-value pair in the localStorage.
 *
 * @param {string} key - The key to set in localStorage.
 */
export const removeKey = (key: string) => {
  if (typeof window !== "undefined") {
    localStorage.removeItem(key);
  }
};

/**
 * Retrives a token and its value from localStorage
 * Generally the token is AccessToken sent by
 * server
 */
export const accessToken = () => {
  return getKey("token");
};

// export const permissions = () => {
//   const authToken = JSON.parse(getKey('userAuth'));
//   const {accessToken, refreshToken, permissions, user} = authToken;
//   return permissions
// }
